<workflow-hot-wire src="assets/images/tests/VisuomotorischeKoordination.png"></workflow-hot-wire>
